// extracted by mini-css-extract-plugin
export var container = "_gf-0";
export var infoIcon = "_gf-2";
export var internalLabel = "_gf-3";
export var titleRowCol = "_gf-1";